import React, { useState } from 'react';
import './About.css';
import NavBar from './NavBar';
import ContactModal from './ContactModal';
import Footer from './Footer';
import Raiz from './raiz';

/* ── Hero Illustration ── */
const IllustrationHero = () => (
  <svg viewBox="0 0 460 400" fill="none" xmlns="http://www.w3.org/2000/svg" className="hero-illustration">
    <circle cx="240" cy="200" r="155" fill="#e4eeea"/>
    <circle cx="100" cy="88"  r="6" fill="#c8dbd2"/>
    <circle cx="390" cy="105" r="5" fill="#c8dbd2"/>
    <circle cx="420" cy="262" r="7" fill="#c8dbd2"/>
    <circle cx="68"  cy="295" r="5" fill="#c8dbd2"/>
    <circle cx="152" cy="340" r="4" fill="#c8dbd2"/>
    <circle cx="356" cy="345" r="4" fill="#c8dbd2"/>
    <rect x="148" y="90"  width="200" height="150" rx="10" fill="#fff" stroke="#c8d8d0" strokeWidth="2"/>
    <rect x="148" y="90"  width="200" height="38"  rx="10" fill="#2e6b4a"/>
    <rect x="148" y="110" width="200" height="18"  fill="#2e6b4a"/>
    <circle cx="166" cy="109" r="4" fill="rgba(255,255,255,0.3)"/>
    <circle cx="180" cy="109" r="4" fill="rgba(255,255,255,0.3)"/>
    <circle cx="194" cy="109" r="4" fill="rgba(255,255,255,0.3)"/>
    <rect x="286" y="148" width="14" height="42" rx="3" fill="#3a7a58" opacity="0.75"/>
    <rect x="305" y="163" width="14" height="27" rx="3" fill="#7ab595" opacity="0.75"/>
    <rect x="324" y="155" width="14" height="35" rx="3" fill="#3a7a58" opacity="0.5"/>
    <rect x="162" y="148" width="80"  height="7" rx="3" fill="#c8dbd2"/>
    <rect x="162" y="162" width="100" height="6" rx="3" fill="#dde8e3"/>
    <rect x="162" y="174" width="88"  height="6" rx="3" fill="#dde8e3"/>
    <rect x="162" y="186" width="60"  height="6" rx="3" fill="#dde8e3"/>
    <rect x="162" y="205" width="55" height="24" rx="4" fill="#e4eeea"/>
    <rect x="170" y="212" width="38" height="5"  rx="2" fill="#b0c8bc"/>
    <rect x="170" y="220" width="26" height="4"  rx="2" fill="#c8dbd2"/>
    <rect x="228" y="205" width="55" height="24" rx="4" fill="#e4eeea"/>
    <rect x="236" y="212" width="38" height="5"  rx="2" fill="#b0c8bc"/>
    <rect x="236" y="220" width="20" height="4"  rx="2" fill="#c8dbd2"/>
    <rect x="228" y="240" width="40" height="14" rx="2" fill="#c8d8d0"/>
    <rect x="212" y="252" width="72" height="6"  rx="3" fill="#b8ccc4"/>
    <rect x="76"  y="106" width="116" height="64" rx="9" fill="#fff" stroke="#dde8e3" strokeWidth="1.5"/>
    <circle cx="99" cy="128" r="11" fill="#e4eeea"/>
    <line x1="99" y1="122" x2="99"  y2="134" stroke="#3a7a58" strokeWidth="2.2" strokeLinecap="round"/>
    <line x1="93" y1="128" x2="105" y2="128" stroke="#3a7a58" strokeWidth="2.2" strokeLinecap="round"/>
    <rect x="116" y="120" width="62" height="7" rx="3" fill="#c8dbd2"/>
    <rect x="116" y="132" width="48" height="5" rx="2" fill="#dde8e3"/>
    <rect x="92"  y="150" width="24" height="6" rx="3" fill="#3a7a58" opacity="0.45"/>
    <rect x="120" y="150" width="16" height="6" rx="3" fill="#7ab595" opacity="0.55"/>
    <rect x="140" y="150" width="12" height="6" rx="3" fill="#aacebb" opacity="0.5"/>
    <rect x="298" y="268" width="118" height="60" rx="9" fill="#fff" stroke="#dde8e3" strokeWidth="1.5"/>
    <rect x="314" y="284" width="84" height="7"  rx="3" fill="#c8dbd2"/>
    <rect x="314" y="297" width="68" height="5"  rx="2" fill="#dde8e3"/>
    <rect x="314" y="308" width="76" height="5"  rx="2" fill="#dde8e3"/>
  </svg>
);


const services = [
  { title: 'Sistemas de gestión clínica',              desc: 'Implementamos soluciones de gestión clínica eficientes.' },
  { title: 'Desarrollo web y aplicaciones a medida',   desc: 'Creamos sitios web y apps personalizadas.' },
  { title: 'Integraciones y automatización de procesos', desc: 'Automatizamos y conectamos sistemas clínicos.' },
  { title: 'Servicio técnico de laboratorio',          desc: 'Mantenimiento y reparación de equipo de laboratorio delicado.' },
];

function About() {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <div className="About">
      <NavBar />

      {/* Hero */}
      <section className="ab-hero">
        <div className="ab-hero-content">
          <span className="ab-badge">Innovación y Tecnología Clínica</span>
          <h1 className="ab-title">Sobre Nosotros</h1>
          <p className="ab-lead">
            Fundada en 2025, fusionamos conocimiento técnico
            en equipamiento de laboratorio con desarrollo de software para
            gestión clínica y aplicaciones web personalizadas.
          </p>
          <Raiz text="Contáctanos" onClick={() => setIsModalOpen(true)} />
        </div>
        <div className="ab-hero-illustration">
          <IllustrationHero />
        </div>
      </section>

      {/* Lo que hacemos */}
      <section className="ab-services">
        <h2 className="ab-section-title">Lo que hacemos</h2>
        <div className="ab-cards">
          {services.map((s, i) => (
            <div key={i} className="ab-card">
              <h3 className="ab-card-title">{s.title}</h3>
              <p className="ab-card-desc">{s.desc}</p>
            </div>
          ))}
        </div>
      </section>

      {/* Value props */}
      <section className="ab-values">
        <p className="ab-values-statement">
          No solo desarrollamos software.<br />
          Entendemos el entorno técnico <strong>donde se usa</strong>.
        </p>
        <div className="ab-values-cols">
          <div className="ab-value">
            <h4>Innovación digital</h4>
            <p>Adaptamos las últimas tecnologías a las necesidades del sector salud.</p>
          </div>
          <div className="ab-value">
            <h4>Criterio técnico</h4>
            <p>Soluciones completas, desde el hardware hasta el código.</p>
          </div>
        </div>
      </section>

      {/* Closing */}
      <section className="ab-closing">
        <p>
          Mantenemos como pilar fundamental el{' '}
          <strong>servicio técnico especializado en equipamiento delicado de laboratorio</strong>,
          {' '}combinando precisión técnica con innovación digital para ofrecer
          soluciones completas y confiables.
        </p>
      </section>

      <Footer />

      <ContactModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
    </div>
  );
}

export default About;
